import { arrayOf, objectOf } from "@altostra/type-validations";
import { number, string } from "@altostra/type-validations/lib/primitives";

import type {
  CreativeVariantAction,
  CreativeVariantWarning,
  PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult,
} from "./types";

export const isGetDataTableDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult =
  objectOf({
    hits: number,
    results: arrayOf(
      objectOf({
        id: string,
        creative: string,
        compatibleBaseCreativeCampaignIds: arrayOf(string),
      })
    ),
  });

export const isCreativeVariantWarning = objectOf<CreativeVariantWarning>({
  type: string,
  message: string,
});

export const isCreativeVariantAction = objectOf<CreativeVariantAction>({
  actionId: number,
  creative: string,
  compatibleBaseCreativeCampaignIds: arrayOf(string),
});

export const isPostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult =
  objectOf<PostDecisioningStudioAgentsAppGroupIdDsaIdCreativeVariantsDimensionsDimensionResult>({
    action: isCreativeVariantAction,
    warnings: arrayOf(isCreativeVariantWarning),
  });
